import type { BookingDetailsState, FullCancellationCostsState } from '../../domain/types'
import type { Locale } from '@/intl/types'
import { formatDate } from '@/scopes/account/common/formatters'

export type FullCancellationVariant = 'free' | 'with-cost' | null

export type FullCancellationSheetVariant = Exclude<FullCancellationVariant, null>

type FullCancellationVariantFlag = keyof Pick<
  FullCancellationCostsState,
  'isFreeCancellationAllowed' | 'isCancellationWithCostsAllowed'
>

const FULL_CANCELLATION_VARIANT_RULES = [
  ['isFreeCancellationAllowed', 'free'],
  ['isCancellationWithCostsAllowed', 'with-cost'],
] as const satisfies ReadonlyArray<readonly [FullCancellationVariantFlag, FullCancellationSheetVariant]>

export function getFullCancellationVariant(state: BookingDetailsState): FullCancellationVariant {
  const costs = state.fullCancellationCosts

  if (costs.status !== 'success')
    return null

  return FULL_CANCELLATION_VARIANT_RULES.find(([flag]) => costs[flag])?.[1] ?? null
}

export function getFullCancellationPaymentDueDate(
  locale: Locale,
  currentDate: Date = new Date(),
): string {
  const tomorrow = new Date(currentDate)
  tomorrow.setDate(tomorrow.getDate() + 1)

  const isoDate = tomorrow.toISOString().slice(0, 10)
  return formatDate(isoDate, locale)
}
